/* eslint-disable no-console */
/* eslint-disable camelcase */
let config_env = {
	API: 'https://api-sol.lucree.com.br/v1/',
	API_CREDENCIAMENTO: 'https://api.lucree.com.br/credenciamento/',
	API_AUTH: 'https://api.lucree.com.br/autenticacao/v1',
	API_PLANOS: 'https://api2.lucree.com.br/',
	API_PROJETOS: 'https://api.lucree.com.br/projetos/',
	API_GATEWAY_PAGAMENTOS: 'https://ecommerce.lucree.com.br/',
	API_GRUPO_ECONOMICO: 'https://api.lucree.com.br/grupoeconomico/',
	API_ENTREGAS: 'https://api.lucree.com.br/entregas/',
	API_SIMULADOR: 'https://simulador.lucree.com.br/api/',
	API_REPORT_COMERCIAL: 'https://comercial.lucree.com.br/',
	API_EQUIPAMENTOS: 'https://equipamentos.lucree.com.br/',
	API_CREDENCIAMENTO_LOJISTA:
		'https://api-hml.lucree.com.br/credenciamento/lojista',
	API_HIERARQUIA: 'https://api-hierarquia.lucree.com.br/',
	API_EMPRESTIMO: 'https://api.lucree.com.br/adquirentes/',
	API_LIQUIDACAO: 'https://api-liquidacao.lucree.com.br/',
	API_PARAMETRIZACAO: 'https://param.lucree.com.br/',
	API_CONCILIACAO: 'https://conciliacao.lucree.com.br/',

	API_VIACEP: 'https://viacep.com.br/ws/',

	API_FISCAL: 'https://api.lucree.com.br/fiscal/',

	API_INTEGRADOR: 'https://integrador.lucree.com.br/',

	FAQ_QUERY: 'faq/',
	MOTIVOS_QUERY: 'motivos/',
	PESSOAS_FILTER_CNPJ_CPF: 'pessoas/?cnpj_cpf=',
	PESSOAS_FILTER_EMAIL: 'pessoas/?email=',
	SOLICITACOES_FILTER_EMAIL: 'solicitacoes/?solicitante_email=',
	SOLICITACOES_BY_ID: 'solicitacoes/',
	SOLICITACOES_BY_CLIENTE_CNPJ_CPF: 'solicitacoes/?cliente_cnpj_cpf=',
	DEPARTAMENTOS: 'departamentos/',
	SOLICITACOES_FILTER_DEPARTAMENTOS: 'solicitacoes/?departamento_array=',
	COMENTARIOS_FILTER_SOLICITACAO: 'comentarios/?solicitacao_id=',
	ANEXOS_FILTER_SOLICITACAO: 'anexos/?solicitacao_id=',
	CAMPOS_FILTER_SOLICITACAO: 'campos/?solicitacao_id=',
	ATIVIDADES_FILTER_SOLICITACAO: 'atividades/?solicitacao_id=',
	CLIENTE_POR_DOCUMENTO: 'cliente/?cnpj_cpf=',
	ENDERECO_POR_DOCUMENTO: 'endereco/?cnpj_cpf=',
	DADOS_BANCARIOS_POR_DOCUMENTO: 'dados_bancarios/?cnpj_cpf=',
	DADOS_PESSOAIS_POR_DOCUMENTO: 'dados_pessoais/?cnpj_cpf=',
	PEDIDOS_POR_DOCUMENTO: 'pedidos/?cnpj_cpf=',

	BACKOFFICE_USER: 'backoffice?email=',

	AUTH_TOKEN_QUERY: 'api-token-auth/',
	RESET_TOKEN_VERIFY: 'reset-pass/verify/?token=',
	RESET_TICKET: 'reset-ticket/?email=',
	RESET_PASS: 'reset-pass/?token=',
	VERIFY_EMAIL: 'verify/?email=',
	REFRESH_TOKEN_QUERY: 'api-token-refresh/',
	ANEXOS_QUERY: 'anexos/',
	AGENTE_QUERY: 'agente/',
	AGENTE_ESTOQUE: 'estoque-avancado/check-estoque-avancado/',
	TERMINAL_CAD_QUERY: 'arquivo/v1/upload-documento/',
	TERMINAL_ARQUIVO_QUERY: 'arquivo/v1/',
	TERMINAL_VERIFICAR_QUERY: 'arquivo/v1/upload-processado/',
	RAMOS_ATIVIDADES_QUERY: 'ramo-atividade/',
	RAMOS_ATIVIDADES_MCC_QUERY: 'ramo-mcc/',
	OCUPACAO_ATIVIDADES: 'ocupacoes/',
	CLIENTE_ATIVO_QUERY: 'cliente-ativo?document=',
	EMAIL_ATIVO_QUERY: 'email-ativo?email=',
	DOMICILIOS_BANCARIOS_QUERY: 'domicilio-bancario/',
	OPERADORAS_PREFERENCIAS_QUERY: 'operadora-preferencia/',
	TIPOS_CONTAS_QUERY: 'tipo-conta/',
	FORMAS_PAGAMENTOS_QUERY: 'forma-pagamento/',
	TIPOS_MAQUINAS_QUERY: 'tipo-maquina/',
	PROMO_QUERY: 'promos/bevid2',
	ANALISE_QUERY: 'analise/',
	ATIVIDADE_QUERY: 'atividade/',
	HIERARQUIA_QUERY: 'hierarquia/',
	CLIENTE_QUERY: 'cliente/',
	CLIENTE_FILTER_QUERY: 'clientes/',
	CLIENTE_PROPOSTAS: 'propostas/',
	CLIENTE_QUERY_PAGAMENTO: 'cliente-pagamento/',
	CLIENTE_QUERY_ANALISE: 'cliente-analise/',
	CLIENTE_QUERY_PV_RECUSAR: 'cliente-pv-recusado/',
	CLIENTE_QUERY_PV_MANUAL: 'cliente-pv-manual/',
	CLIENTE_QUERY_ATUALIZAR_PROPOSAL: 'cliente-atualizar-proposal/',
	AGENTE_ANEXOS_QUERY: 'agente/anexo/',
	ADICIONAL_MAQUINA_QUERY: 'adicional-maquina/',
	ADICIONAL_MAQUINA_ANEXOS_QUERY: 'adicional-maquina/anexo/',
	UPDATE_MAQUINA: 'cliente-update-maquina',
	CLIENTE_ANEXOS_QUERY: 'anexo/',
	FASES_QUERY: 'fase/',
	STATUS_QUERY: 'status/',
	ETAPAS_QUERY: 'fase/',
	CLIENTE_FASE_QUERY: 'cliente-fase/?cliente=',
	GERAR_BOLETO_QUERY: 'cria-boleto',
	ENCERRAR_SOLICITACAO: 'solicitacao/',
	AUTH_TOKEN: 'Token d5c72edacef911498f28bfadc209a7d0bd177f0d',

	USER_AUTHENTICATION_DEV: 'daniel.nascimento',
	USER_AUTHENTICATION_PASS_DEV: 'acessoLucree#2018',

	/*
	USER_AUTHENTICATION_DEV: process.env.REACT_APP_AUTHENTICATION_LOGIN || 'daniel.nascimento',
	USER_AUTHENTICATION_PASS_DEV: process.env.REACT_APP_AUTHENTICATION_PASS || 'acessoLucree#2018',
	*/
};

function noop() {}

if (process.env.NODE_ENV !== 'development') {
	if (window.location.hostname.indexOf('-homolog') !== -1) {
		// homolog
		config_env = {
			...config_env,
			API: 'https://api-sol-hml.lucree.com.br/v1/',
			API_CREDENCIAMENTO: 'https://api-hml.lucree.com.br/credenciamento/',
			API_AUTH: 'https://api-hml.lucree.com.br/autenticacao/v1',
			API_PLANOS: 'https://api2-hml.lucree.com.br/',
			API_PROJETOS: 'https://api-hml.lucree.com.br/projetos/',
			API_GATEWAY_PAGAMENTOS: 'https://ecommerce-stage.lucree.com.br/',
			API_GRUPO_ECONOMICO:
				'https://api-hml.lucree.com.br/grupoeconomico/',
			API_ENTREGAS: 'https://api-hml.lucree.com.br/entregas/',
			API_SIMULADOR: 'https://simulador-hml.lucree.com.br/api/',
			API_REPORT_COMERCIAL: 'https://comercial-hml.lucree.com.br/',
			API_EQUIPAMENTOS:
				'https://lucree-equipamentos-hml-elb-2034745431.us-west-2.elb.amazonaws.com/',
			API_HIERARQUIA: 'https://api-hierarquia-hml.lucree.com.br/',
			API_EMPRESTIMO: 'https://api-hml.lucree.com.br/adquirentes/',
			API_LIQUIDACAO: 'https://api-liquidacao-prod.lucree.com.br/',
			API_INTEGRADOR: 'https://homolog.lucree.com.br/',
			API_PARAMETRIZACAO: 'https://param-hml.lucree.com.br/',
			API_CONCILIACAO: 'https://gandalf-hml.lucree.com.br/liquidacao/',
			API_FISCAL: 'https://api-hml.lucree.com.br/fiscal/',
		};
	} else {
		// production
		console.warn = noop;
	}
} else {
	config_env = {
		...config_env,
		API: 'https://api-sol.lucree.com.br/v1/',
		API_CREDENCIAMENTO: 'https://api-hml.lucree.com.br/credenciamento/',
		API_AUTH: 'https://api-hml.lucree.com.br/autenticacao/v1',
		API_PLANOS: 'https://api2-hml.lucree.com.br/',
		API_PROJETOS: 'https://api-hml.lucree.com.br/projetos/',
		API_GATEWAY_PAGAMENTOS: 'https://ecommerce-stage.lucree.com.br/',
		API_GRUPO_ECONOMICO: 'https://api-hml.lucree.com.br/grupoeconomico/',
		API_ENTREGAS: 'https://api-hml.lucree.com.br/entregas/',
		API_SIMULADOR: 'https://simulador-hml.lucree.com.br/api/',
		API_REPORT_COMERCIAL: 'https://comercial-hml.lucree.com.br/',
		API_EQUIPAMENTOS: 'http://0.0.0.0:5000/',
		API_HIERARQUIA: 'https://api-hierarquia-hml.lucree.com.br/',
		API_EMPRESTIMO: 'https://api-hml.lucree.com.br/adquirentes/',
		API_LIQUIDACAO: 'https://api-liquidacao.lucree.com.br/',
		API_INTEGRADOR: 'http://localhost:8000/',
		API_FISCAL: 'https://api.lucree.com.br/fiscal/',

		API_PARAMETRIZACAO: 'https://param-hml.lucree.com.br/',
		API_CONCILIACAO: 'https://gandalf-hml.lucree.com.br/liquidacao',
	};
}

export const config = config_env;
